import { paragraph, paragraphCss } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div`
  display: grid;

  grid-template-columns: repeat(auto-fit, minmax(min(600px, 100%), 1fr));

  gap: 34px;
  margin-bottom: 34px;

  @media screen and (max-width: 992px) {
    gap: 16px;
    margin-bottom: 16px;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;

  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }
`;

const Image = styled(GatsbyImage)`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  object-position: center;
`;

const ImageLink = styled(Link)`
  ${paragraphCss}
  color: ${({ theme }) => theme.colors.softBlack};
  text-decoration: none;

  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }
`;

const Text = styled(paragraph)`
  color: ${({ theme }) => theme.colors.softBlack};
`;

const S = {
  Container,
  ImageWrapper,
  Image,
  ImageLink,
  Text,
};

export default S;
